import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function IdeaValidation(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props} viewBox="0 0 60 60">
      <path
        d="M11.3582 12.4461H1.70365V2.74427H8.04526L9.37039 1.04053H0.851699C0.378304 1.04053 0 1.41918 0 1.89223V13.2978C0 13.7712 0.37865 14.1495 0.851699 14.1495H12.2573C12.7307 14.1495 13.109 13.7709 13.109 13.2978L13.1093 4.63714L11.4056 6.86146V12.4461H11.3582Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M5.01611 6.29378C4.73221 5.91513 4.21161 5.82039 3.83296 6.10462C3.45431 6.38853 3.35957 6.90912 3.6438 7.28777L5.53668 9.79605C5.67863 10.0328 5.96253 10.1275 6.19922 10.1275C6.48313 10.1275 6.71983 9.98555 6.86177 9.79605L12.5408 2.3657C12.8247 1.98705 12.7775 1.46642 12.3989 1.18255C12.0202 0.89864 11.4996 0.945847 11.2157 1.3245L6.24639 7.90282L5.01611 6.29378Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M17.3208 5.8204H40.0373C40.6999 5.8204 41.2205 5.2998 41.2205 4.63725C41.2205 3.97471 40.6999 3.4541 40.0373 3.4541H17.3208C16.6583 3.4541 16.1377 3.97471 16.1377 4.63725C16.1377 5.2998 16.6583 5.8204 17.3208 5.8204Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M17.3208 11.6891H33.601C34.2636 11.6891 34.7842 11.1685 34.7842 10.5059C34.7842 9.84336 34.2636 9.32275 33.601 9.32275H17.3208C16.6583 9.32275 16.1377 9.84336 16.1377 10.5059C16.1377 11.1685 16.6583 11.6891 17.3208 11.6891Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M11.3582 28.3475H1.70365V18.693H8.04526L9.37039 16.9893H0.851699C0.378304 16.9893 0 17.3679 0 17.841V29.1992C0 29.6726 0.37865 30.0509 0.851699 30.0509H12.2573C12.7307 30.0509 13.109 29.6723 13.109 29.1992L13.1093 20.5385L11.4056 22.7629V28.3475H11.3582Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M5.01611 22.2425C4.73221 21.8639 4.21161 21.7691 3.83296 22.0534C3.45431 22.3373 3.35957 22.8579 3.6438 23.2365L5.53668 25.7448C5.67863 25.9815 5.96253 26.0762 6.19922 26.0762C6.48313 26.0762 6.71983 25.9343 6.86177 25.7448L12.5408 18.3144C12.8247 17.9358 12.7775 17.4151 12.3989 17.1313C12.0202 16.8474 11.4996 16.8946 11.2157 17.2732L6.24639 23.8519L5.01611 22.2425Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M40.0373 19.4033H17.3208C16.6583 19.4033 16.1377 19.9239 16.1377 20.5865C16.1377 21.249 16.6583 21.7696 17.3208 21.7696H40.0373C40.6999 21.7696 41.2205 21.249 41.2205 20.5865C41.2205 19.9239 40.6527 19.4033 40.0373 19.4033Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M17.3208 27.6378H33.601C34.2636 27.6378 34.7842 27.1172 34.7842 26.4546C34.7842 25.7921 34.2636 25.2715 33.601 25.2715H17.3208C16.6583 25.2715 16.1377 25.7921 16.1377 26.4546C16.1377 27.1172 16.6583 27.6378 17.3208 27.6378Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M11.3582 44.2967H1.70365V34.5949H8.04526L9.37039 32.8911H0.851699C0.378304 32.8911 0 33.2698 0 33.7428V45.1484C0 45.6218 0.37865 46.0001 0.851699 46.0001H12.2573C12.7307 46.0001 13.109 45.6214 13.109 45.1484L13.1093 36.4877L11.4056 38.712V44.2964L11.3582 44.2967Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M5.01611 38.1444C4.73221 37.7657 4.21161 37.671 3.83296 37.9552C3.45431 38.2391 3.35957 38.7597 3.6438 39.1384L5.53668 41.6466C5.67863 41.8833 5.96253 41.9781 6.19922 41.9781C6.48313 41.9781 6.71983 41.8361 6.86177 41.6466L12.5408 34.2163C12.8247 33.8376 12.7775 33.317 12.3989 33.0331C12.0202 32.7492 11.4996 32.7964 11.2157 33.1751L6.24639 39.8009L5.01611 38.1444Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M40.0373 35.3521H17.3208C16.6583 35.3521 16.1377 35.8727 16.1377 36.5352C16.1377 37.1977 16.6583 37.7184 17.3208 37.7184H40.0373C40.6999 37.7184 41.2205 37.1977 41.2205 36.5352C41.2205 35.8727 40.6527 35.3521 40.0373 35.3521Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M33.601 41.2202H17.3208C16.6583 41.2202 16.1377 41.7408 16.1377 42.4034C16.1377 43.0659 16.6583 43.5865 17.3208 43.5865H33.601C34.2636 43.5865 34.7842 43.0659 34.7842 42.4034C34.7842 41.7408 34.2636 41.2202 33.601 41.2202Z"
        fill="#A57DFB"
        fillOpacity="0.4"
      />
      <path
        d="M14.3582 11.4461H4.70365V1.74427H11.0453L12.3704 0.0405273H3.8517C3.3783 0.0405273 3 0.419178 3 0.892227V12.2978C3 12.7712 3.37865 13.1495 3.8517 13.1495H15.2573C15.7307 13.1495 16.109 12.7709 16.109 12.2978L16.1093 3.63714L14.4056 5.86146V11.4461H14.3582Z"
        fill="black"
      />
      <path
        d="M8.01611 5.29378C7.73221 4.91513 7.21161 4.82039 6.83296 5.10462C6.45431 5.38853 6.35957 5.90912 6.6438 6.28777L8.53668 8.79605C8.67863 9.03275 8.96253 9.1275 9.19922 9.1275C9.48313 9.1275 9.71983 8.98555 9.86177 8.79605L15.5408 1.3657C15.8247 0.987046 15.7775 0.466417 15.3989 0.182545C15.0202 -0.10136 14.4996 -0.0541525 14.2157 0.324498L9.24639 6.90282L8.01611 5.29378Z"
        fill="black"
      />
      <path
        d="M20.3208 4.8204H43.0373C43.6999 4.8204 44.2205 4.2998 44.2205 3.63725C44.2205 2.97471 43.6999 2.4541 43.0373 2.4541H20.3208C19.6583 2.4541 19.1377 2.97471 19.1377 3.63725C19.1377 4.2998 19.6583 4.8204 20.3208 4.8204Z"
        fill="black"
      />
      <path
        d="M20.3208 10.6891H36.601C37.2636 10.6891 37.7842 10.1685 37.7842 9.50591C37.7842 8.84336 37.2636 8.32275 36.601 8.32275H20.3208C19.6583 8.32275 19.1377 8.84336 19.1377 9.50591C19.1377 10.1685 19.6583 10.6891 20.3208 10.6891Z"
        fill="black"
      />
      <path
        d="M14.3582 27.3475H4.70365V17.693H11.0453L12.3704 15.9893H3.8517C3.3783 15.9893 3 16.3679 3 16.841V28.1992C3 28.6726 3.37865 29.0509 3.8517 29.0509H15.2573C15.7307 29.0509 16.109 28.6723 16.109 28.1992L16.1093 19.5385L14.4056 21.7629V27.3475H14.3582Z"
        fill="black"
      />
      <path
        d="M8.01611 21.2425C7.73221 20.8639 7.21161 20.7691 6.83296 21.0534C6.45431 21.3373 6.35957 21.8579 6.6438 22.2365L8.53668 24.7448C8.67863 24.9815 8.96253 25.0762 9.19922 25.0762C9.48313 25.0762 9.71983 24.9343 9.86177 24.7448L15.5408 17.3144C15.8247 16.9358 15.7775 16.4151 15.3989 16.1313C15.0202 15.8474 14.4996 15.8946 14.2157 16.2732L9.24639 22.8519L8.01611 21.2425Z"
        fill="black"
      />
      <path
        d="M43.0373 18.4033H20.3208C19.6583 18.4033 19.1377 18.9239 19.1377 19.5865C19.1377 20.249 19.6583 20.7696 20.3208 20.7696H43.0373C43.6999 20.7696 44.2205 20.249 44.2205 19.5865C44.2205 18.9239 43.6527 18.4033 43.0373 18.4033Z"
        fill="black"
      />
      <path
        d="M20.3208 26.6378H36.601C37.2636 26.6378 37.7842 26.1172 37.7842 25.4546C37.7842 24.7921 37.2636 24.2715 36.601 24.2715H20.3208C19.6583 24.2715 19.1377 24.7921 19.1377 25.4546C19.1377 26.1172 19.6583 26.6378 20.3208 26.6378Z"
        fill="black"
      />
      <path
        d="M14.3582 43.2967H4.70365V33.5949H11.0453L12.3704 31.8911H3.8517C3.3783 31.8911 3 32.2698 3 32.7428V44.1484C3 44.6218 3.37865 45.0001 3.8517 45.0001H15.2573C15.7307 45.0001 16.109 44.6214 16.109 44.1484L16.1093 35.4877L14.4056 37.712V43.2964L14.3582 43.2967Z"
        fill="black"
      />
      <path
        d="M8.01611 37.1444C7.73221 36.7657 7.21161 36.671 6.83296 36.9552C6.45431 37.2391 6.35957 37.7597 6.6438 38.1384L8.53668 40.6466C8.67863 40.8833 8.96253 40.9781 9.19922 40.9781C9.48313 40.9781 9.71983 40.8361 9.86177 40.6466L15.5408 33.2163C15.8247 32.8376 15.7775 32.317 15.3989 32.0331C15.0202 31.7492 14.4996 31.7964 14.2157 32.1751L9.24639 38.8009L8.01611 37.1444Z"
        fill="black"
      />
      <path
        d="M43.0373 34.3521H20.3208C19.6583 34.3521 19.1377 34.8727 19.1377 35.5352C19.1377 36.1977 19.6583 36.7184 20.3208 36.7184H43.0373C43.6999 36.7184 44.2205 36.1977 44.2205 35.5352C44.2205 34.8727 43.6527 34.3521 43.0373 34.3521Z"
        fill="black"
      />
      <path
        d="M36.601 40.2202H20.3208C19.6583 40.2202 19.1377 40.7408 19.1377 41.4034C19.1377 42.0659 19.6583 42.5865 20.3208 42.5865H36.601C37.2636 42.5865 37.7842 42.0659 37.7842 41.4034C37.7842 40.7408 37.2636 40.2202 36.601 40.2202Z"
        fill="black"
      />
    </IconWrapper>
  );
}
